import _UserManager from "./user.manager";
/* Export functions individually*/
export const UserManager = _UserManager;
